import { call, put, select } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { fetchMt5SMainTable, fetchOne5SCardById, deleteMt5SCard } from '../../api/api';
import {
  loadMainTableSuccess,
  loadMainTableFailure,
  loadEditCardSuccess,
  loadEditCardFailure,
  loadMainTable,
  deleteCardSuccess,
  deleteCardFailure,
} from './actions';
import {
  LoadTableRequestAction,
  LoadEditCardRequestAction,
  DeleteCardRequestAction,
} from '../../types/mainTable5S';

export function* loadMainTableSaga(action: LoadTableRequestAction) {
  const { params } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(fetchMt5SMainTable, params);
    if (response.data?.success) {
      yield put(loadMainTableSuccess(response.data.data));
    } else {
      yield put(loadMainTableFailure(response.data?.error || 'Не удалось загрузить таблицу 5S'));
    }
  } catch (error) {
    const errorMessage = (error as any)?.message || 'Ошибка загрузки таблицы 5S';
    yield put(loadMainTableFailure(errorMessage));
  }
}

export function* loadEditCardSaga(action: LoadEditCardRequestAction) {
  const { id } = action.payload;
  try {
    const response: AxiosResponse<any> = yield call(fetchOne5SCardById, id);
    const item = response.data?.data?.[0];
    if (item) {
      yield put(loadEditCardSuccess(item));
    } else {
      yield put(loadEditCardFailure('Карточка не найдена'));
    }
  } catch (error) {
    const errorMessage = (error as any)?.message || 'Ошибка загрузки карточки';
    yield put(loadEditCardFailure(errorMessage));
  }
}

export function* deleteCardSaga(action: DeleteCardRequestAction) {
  const { id } = action.payload;
  try {
    yield call(deleteMt5SCard, id);
    yield put(deleteCardSuccess(id));
    yield call(refreshMainTableSaga);
  } catch (error) {
    const errorMessage = (error as any)?.message || 'Не удалось удалить аудит';
    yield put(deleteCardFailure(errorMessage));
  }
}

export function* refreshMainTableSaga() {
  const lastParams: Record<string, any> = yield select(
    (state: any) => state.myTasksStrapi.mainTable5S.table.data?.filters
  );
  const params = lastParams && Object.keys(lastParams).length > 0
    ? lastParams
    : { year: new Date().getFullYear() };
  yield put(loadMainTable(params));
}
